import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26460df2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "logo",
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.0",
  width: "150px",
  height: "150px",
  viewBox: "0 0 700.000000 700.000000",
  preserveAspectRatio: "xMidYMid meet"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    transform: "translate(0.000000,700.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none",
    style: {"fill":"#eee"}
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M1510 6389 c-78 -9 -135 -35 -174 -81 -82 -96 -79 -271 6 -359 77 -79 11 -73 972 -79 l859 -5 0 -1694 0 -1694 -66 -24 c-169 -60 -290 -186 -338 -350 -21 -70 -29 -230 -16 -303 26 -142 89 -309 160 -418 24 -37 102 -135 173 -217 186 -216 258 -322 314 -465 28 -71 46 -90 85 -90 40 0 54 16 90 105 61 152 158 290 350 500 59 65 140 176 174 240 31 57 86 201 95 248 3 12 10 47 16 77 16 80 14 235 -4 303 -41 151 -142 275 -277 339 -41 20 -87 40 -104 45 l-30 10 0 1693 c0 1121 3 1694 10 1696 5 2 393 5 860 6 l850 3 52 29 c87 48 123 118 123 236 0 133 -72 220 -203 246 -41 9 -3904 11 -3977 3z" })
  ])
], -1))
const _hoisted_3 = {
  key: 0,
  class: ""
}
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Project name:", -1))
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: ""
}
const _hoisted_11 = {
  key: 0,
  class: "field"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "control" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Selected:", -1))
const _hoisted_15 = { class: "data" }
const _hoisted_16 = { class: "control" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Version", -1))
const _hoisted_18 = { class: "data" }
const _hoisted_19 = { class: "row control" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Duplicate as:", -1))
const _hoisted_21 = { class: "row control" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "projects-chooser" }
const _hoisted_24 = { class: "buttons-flex" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sync-alt" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye-slash" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "projects-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectsChooserProject = _resolveComponent("ProjectsChooserProject")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.toggleDuplicate === false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  class: "input is-small",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.newProjectName = $event)),
                  placeholder: "example (en-GB)"
                }, null, 512), [
                  [_vModelText, _ctx.newProjectName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "button is-small is-primary",
                  disabled: _ctx.newProjectName?.trim().length === 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add()))
                }, "New project", 8, _hoisted_9)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.toggleDuplicate === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.toDuplicateProject)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.toDuplicateProject.projectName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.toDuplicateProject.version || "null"), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _withDirectives(_createElementVNode("input", {
                      class: "input is-small",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.duplicateProjectName = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.duplicateProjectName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      class: "button is-small is-primary",
                      disabled: _ctx.duplicateProjectName?.trim().length === 0,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.duplicate()))
                    }, "Duplicate project", 8, _hoisted_22),
                    _createElementVNode("button", {
                      class: "button is-small is-primary red",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.turnOffDuplication()))
                    }, "Cancel")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _withDirectives(_createElementVNode("input", {
          class: "input",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.projectQuery = $event)),
          placeholder: _ctx.searchByID ? 'Search by ID' : 'Search by Name'
        }, null, 8, _hoisted_25), [
          [_vModelText, _ctx.projectQuery]
        ]),
        _createElementVNode("button", {
          class: _normalizeClass(["button", { on: _ctx.searchByID }]),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchByID = !_ctx.searchByID))
        }, " \"#ID\" ", 2),
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.refresh()))
        }, _hoisted_27),
        _createElementVNode("button", {
          class: _normalizeClass(["button", { on: _ctx.showHidden }]),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showHidden = !_ctx.showHidden))
        }, _hoisted_29, 2)
      ]),
      _createElementVNode("div", _hoisted_30, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "project-container",
            key: i
          }, [
            (!project.hiddenAt || _ctx.showHidden)
              ? (_openBlock(), _createBlock(_component_ProjectsChooserProject, {
                  key: 0,
                  project: project,
                  onSelectToDuplicate: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectToDuplicate($event))),
                  onLoadPkg: ($event: any) => (_ctx.loadPkg($event, project)),
                  onAddPkg: ($event: any) => (_ctx.addPkg(project)),
                  onAddProjectTag: ($event: any) => (_ctx.addProjectTag($event, project)),
                  onUpdateProject: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateProject($event)))
                }, null, 8, ["project", "onLoadPkg", "onAddPkg", "onAddProjectTag"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}